import { MsalAuthenticationResult, useAzureAuth } from "@datamole/wds-azure-auth";
import { useEffect } from "react";

import { AZURE_AD_INTERACTION_TYPE } from "@/features/auth/constants";

/**
 * Component to render if any error occurs, i.e. if user cancels the flow
 * You typically want to init login again, redirect to login page, etc.
 */

// TODO: Show a proper error message to the user
export const AuthAzureErrorComponent = ({ error }: MsalAuthenticationResult) => {
    const { triggerLogout } = useAzureAuth({
        interactionType: AZURE_AD_INTERACTION_TYPE,
    });

    useEffect(() => {
        // Logout to clear any stale state
        triggerLogout();
    }, [triggerLogout]);

    console.error(error?.errorMessage);
    return null;
};
